import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { keyStore } from "./store/key.atom";
import AppContainer from "./pages/AppContainer";

function App(config: { theme: string; "api-key": string }) {
  const [key, setKey] = useRecoilState(keyStore);
  const [themed, setTheme] = useRecoilState(keyStore);
  const [error, setError] = useState(false);

  const hex2rgb = (hex: string) => {
    const red = parseInt(hex.slice(1, 3), 16);
    const green = parseInt(hex.slice(3, 5), 16);
    const blue = parseInt(hex.slice(5, 7), 16);

    return { red, green, blue };
  };

  useEffect(() => {
    const r = document.querySelector(":root") as HTMLElement;

    console.log(config);

    const code = config["api-key"];
    const theme = config.theme;

    if (theme) {
      const { red, green, blue } = hex2rgb(theme);
      const temp = `${red} ${green} ${blue}`;
      setTheme(temp);
      r.style.setProperty("--sb-primary-color", temp);
    }

    if (code && code.length === 36) {
      setKey(code);
    } else {
      setError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <span className="bg-red-700 p-5 text-xl text-white">
          Please Provide A Working Key
        </span>
      </div>
    );
  }

  if (!key || !themed) {
    return <></>;
  }

  return <AppContainer />;
}

export default App;
